import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dashboard__section" }
const _hoisted_2 = { class: "dashboard__header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, "Your Players", -1)
const _hoisted_4 = { class: "overflow-container" }
const _hoisted_5 = { class: "table" }
const _hoisted_6 = { class: "table__cell--centered text--large" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", { class: "players__discord-accounts-header" }, " Discord Accounts ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", { class: "players__steam-accounts-header" }, " Steam Accounts ", -1)
const _hoisted_9 = { class: "players__created-date-header table__cell--clickable" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Created Date ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", { class: "players__eye-icon-header" }, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", { class: "players__avatar-cell" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "players__avatar-container" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "loading-avatar" })
  ])
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { class: "table__cell--centered" }, null, -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "players__avatar-cell table__cell--centered" }
const _hoisted_17 = {
  key: 0,
  class: "loading-avatar"
}
const _hoisted_18 = ["src", "onError"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 3 }
const _hoisted_25 = { class: "table__cell--clickable" }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("tr", { class: "players__no-players" }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "5" }, "No players found.")
], -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "overflow-container" }
const _hoisted_30 = { class: "pagination" }
const _hoisted_31 = { class: "pagination__item" }
const _hoisted_32 = { class: "pagination__item--desktop" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "pagination__item--desktop" }
const _hoisted_35 = { class: "pagination__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_input_text_group = _resolveComponent("input-text-group")!
  const _component_external_anchor = _resolveComponent("external-anchor")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_input_text_group, {
        class: "players__search",
        placeholder: "Discord or Steam ID",
        modelValue: _ctx.searchTerm,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
        modelModifiers: { trim: true },
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setPage(0, _ctx.searchTerm)))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_fa_icon, {
            class: "text--large",
            icon: ['far', 'search']
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("table", _hoisted_5, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", _hoisted_6, [
              _createVNode(_component_fa_icon, { icon: ['far', 'user-alien'] })
            ]),
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("th", _hoisted_9, [
              _createElementVNode("button", {
                class: "table__cell-button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.flipSortDirection && _ctx.flipSortDirection(...args)))
              }, [
                _hoisted_10,
                (_ctx.sortDirection === 'desc')
                  ? (_openBlock(), _createBlock(_component_fa_icon, {
                      key: 0,
                      icon: ['fad', 'sort-down']
                    }))
                  : _createCommentVNode("", true),
                (_ctx.sortDirection === 'asc')
                  ? (_openBlock(), _createBlock(_component_fa_icon, {
                      key: 1,
                      icon: ['fad', 'sort-up']
                    }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _hoisted_11
          ])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.max(1, _ctx.playersResponse?.data.length ?? 10), (i) => {
                return (_openBlock(), _createElementBlock("tr", { key: i }, [
                  _hoisted_13,
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (j) => {
                    return _createElementVNode("td", { key: j }, [
                      _createElementVNode("div", {
                        class: "loading-line",
                        style: _normalizeStyle({ width: `${_ctx.getRandomInt(25, 100)}%` })
                      }, null, 4)
                    ])
                  }), 64)),
                  _hoisted_14
                ]))
              }), 128))
            ]))
          : (_ctx.playersResponse?.data.length)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playersResponse.data, (player) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: player.playerId
                  }, [
                    _createElementVNode("td", _hoisted_16, [
                      (player.avatarErrored)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, " ? "))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            class: "players__avatar",
                            src: _ctx.getAvatar(player),
                            onError: ($event: any) => (player.avatarErrored = true)
                          }, null, 40, _hoisted_18))
                    ]),
                    (player.discordAccounts.length)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(player.discordAccounts, (account, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: account.discordId
                            }, [
                              _createVNode(_component_external_anchor, {
                                class: "anchor--primary",
                                href: `https://discordapp.com/users/${account.discordId}`,
                                "show-icon": false
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(account.discordId), 1)
                                ]),
                                _: 2
                              }, 1032, ["href"]),
                              (index !== player.discordAccounts.length - 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, ", "))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_21, " None ")),
                    (player.steamAccounts.length)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_22, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(player.steamAccounts, (account, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: account.steamId
                            }, [
                              _createVNode(_component_external_anchor, {
                                class: "anchor--primary",
                                href: `https://steamcommunity.com/profiles/${account.steamId}`,
                                "show-icon": false
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(account.steamId), 1)
                                ]),
                                _: 2
                              }, 1032, ["href"]),
                              (index !== player.steamAccounts.length - 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_23, ", "))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_24, " None ")),
                    _createElementVNode("td", null, _toDisplayString(_ctx.getFormattedDate(player.createdDate)), 1),
                    _createElementVNode("td", _hoisted_25, [
                      _createVNode(_component_router_link, {
                        class: "table__cell-button",
                        to: `/dashboard/${_ctx.$route.params.subdomain}/players/${player.playerId}`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_fa_icon, {
                            class: "players__eye-icon text--large",
                            icon: ['far', 'eye']
                          })
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_26, _hoisted_28))
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("ul", _hoisted_30, [
        _createElementVNode("li", _hoisted_31, [
          _createElementVNode("button", {
            class: "pagination__button button--no-bg",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setPage(0)))
          }, [
            _createVNode(_component_fa_icon, { icon: ['far', 'arrow-to-left'] })
          ])
        ]),
        _createElementVNode("li", _hoisted_32, [
          _createElementVNode("button", {
            class: "pagination__button button--no-bg",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setPage(_ctx.currentPage - 1)))
          }, [
            _createVNode(_component_fa_icon, { icon: ['far', 'arrow-left'] })
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.surroundingPages, (page) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "pagination__item",
            key: page
          }, [
            _createElementVNode("button", {
              class: _normalizeClass(['pagination__button',
              page === _ctx.currentPage ? 'button--inverted' : 'button--no-bg']),
              onClick: ($event: any) => (_ctx.setPage(page))
            }, _toDisplayString(page + 1), 11, _hoisted_33)
          ]))
        }), 128)),
        _createElementVNode("li", _hoisted_34, [
          _createElementVNode("button", {
            class: "pagination__button button--no-bg",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setPage(_ctx.currentPage + 1)))
          }, [
            _createVNode(_component_fa_icon, { icon: ['far', 'arrow-right'] })
          ])
        ]),
        _createElementVNode("li", _hoisted_35, [
          _createElementVNode("button", {
            class: "pagination__button button--no-bg",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setPage(_ctx.playersResponse?.totalPages as number)))
          }, [
            _createVNode(_component_fa_icon, { icon: ['far', 'arrow-to-right'] })
          ])
        ])
      ])
    ])
  ]))
}